import { render, staticRenderFns } from "./departmentUpdate.vue?vue&type=template&id=27e8d142&"
import script from "./departmentUpdate.vue?vue&type=script&lang=js&"
export * from "./departmentUpdate.vue?vue&type=script&lang=js&"
import style0 from "./departmentUpdate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports